import { StyleSheet } from 'aphrodite';
import { brandPrimary, white } from '../../../styles/colors';
import { CssSelectors } from '../../../styles/styles';

export const styleSheet = StyleSheet.create({
	mergeContactEntryContainer: {
		alignItems: 'center',
		borderBottom: '1px solid #f0eded',
		display: 'flex',
		fontSize: 14,
		padding: '10px 5px 10px 5px',
		width: '100%',
		...CssSelectors.allChildren(
			{
				cursor: 'pointer',
				display: 'inline-flex',
				marginBottom: 2,
				marginLeft: 5,
			},
			'.emailAddress'
		),
	},
	mergeContactList: {
		maxHeight: 225,
		overflow: 'auto',
		padding: 20,
	},
	mergeContactsButtonContainer: {
		display: 'flex',
		gap: 12,
		padding: 20,
	},
	mergeContactsCloseButton: {
		backgroundImage: 'url(/assets/close-x.svg)',
		backgroundPosition: 'center center',
		backgroundRepeat: 'no-repeat',
		backgroundSize: 14,
		color: 'transparent',
		cursor: 'pointer',
		display: 'inline-block',
		fontSize: 0,
		height: 14,
		width: 14,
	},
	mergeContactsCloseButtonContainer: {
		marginRight: 15,
		marginTop: 15,
		textAlign: 'right',
	},
	mergeContactsHeadline: {
		color: brandPrimary,
		fontSize: 18,
		margin: '0 0 10px',
		textAlign: 'center',
	},
	mergeContactsSubHeadline: {
		fontSize: 14,
		margin: '0 0 20px',
		textAlign: 'center',
		...CssSelectors.allChildren(
			{
				fontWeight: 700,
			},
			'strong'
		),
	},
	mergeContactsWizardOuterContainer: {
		backgroundColor: 'white',
		border: '1px solid #BABABA',
		borderRadius: 8,
		boxShadow: '0px 2px 6px 0px #cccccc',
		left: '50%',
		position: 'fixed',
		top: '50%',
		transform: 'translate(-50%, -50%)',
		width: 600,
		zIndex: 5,
	},
	modalWindow: {
		backgroundColor: white,
		height: '100%',
		left: 0,
		margin: 0,
		opacity: 0.6,
		padding: 0,
		position: 'fixed',
		top: 0,
		width: '100%',
		zIndex: 3,
	},
});
